import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center mb-2" }
const _hoisted_2 = { class: "d-flex align-center mb-2" }
const _hoisted_3 = { class: "d-flex align-center mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_list, {
      subheader: "",
      style: 'height: 50vh; overflow: auto',
      lines: "two"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list_subheader, null, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" Sélectionnez le compte bancaire à conserver ")
          ])),
          _: 1
        }),
        _createVNode(_component_v_text_field_filled, {
          label: "Nom du nouveau compte en banque",
          modelValue: _ctx.toKeepBankAccount.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.toKeepBankAccount.name) = $event)),
          "hide-details": "",
          class: "mb-2",
          outlined: "",
          density: "compact"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_row, {
          "no-gutters": "",
          class: "mb-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_oss_date_picker_filled, {
                  modelValue: _ctx.toKeepBankAccount.startAuthorizedDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toKeepBankAccount.startAuthorizedDate) = $event)),
                  textFieldReadOnly: true,
                  label: "Date de clôture des flux bancaires",
                  mandatory: false,
                  clearable: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _cache[3] || (_cache[3] = _createElementVNode("b", null, "IBAN : ", -1)),
          _createTextVNode(_toDisplayString(" " + _ctx.toKeepIban && (_ctx.toKeepIban !== null || undefined)
                        ? _ctx.toKeepIban
                        : "Non renseigné"), 1)
        ]),
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("b", null, "BIC : ", -1)),
          _createTextVNode(_toDisplayString(" " +
                    (_ctx.toKeepBic &&
                        (_ctx.toKeepBic !== null || _ctx.toKeepBic !== undefined || _ctx.toKeepBic !== ""))
                        ? _ctx.toKeepBic
                        : "Non renseigné"), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("b", null, "Identifiant créancier sepa : ", -1)),
          _createTextVNode(_toDisplayString(" " +
                    (_ctx.toKeepICS && _ctx.toKeepICS !== null && _ctx.toKeepICS && undefined && _ctx.toKeepICS !== "")
                        ? _ctx.toKeepICS
                        : "Non renseigné"), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toMergeBankAccounts, (bankAccount, i) => {
          return (_openBlock(), _createBlock(_component_v_list_item, {
            key: i + bankAccount.id,
            class: "mb-2",
            onClick: ($event: any) => (_ctx.selectToKeepBankAccount(bankAccount)),
            disabled: _ctx.isBudgetInsightAccount(bankAccount),
            density: "compact",
            rounded: "xl",
            border: "",
            lines: "two"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_v_btn_icon, {
                disabled: _ctx.isBudgetInsightAccount(bankAccount),
                color: "primary",
                icon: 
                            bankAccount.id === _ctx.toKeepBankAccount.id
                                ? '$radio_button_checked'
                                : '$radio_button_unchecked'
                        
              }, null, 8, ["disabled", "icon"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"600px"} }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(bankAccount.name), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["onClick", "disabled"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}